import { Component, OnInit } from '@angular/core';
import { _log } from '@shared/aux_helper_environment';
import { IanTranslateService } from 'core/services/ian-core-singleton.service';
import { VideosModalComponent } from '../../videos-modal/videos-modal.component';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-help-rounding-rule',
  templateUrl: './help-rounding-rule.component.html',
  styleUrls: ['./help-rounding-rule.component.scss'],
})
export class HelpRoundingRuleComponent implements OnInit {
  constructor(public dialog: MatDialog, private translate: IanTranslateService) {}

  ngOnInit(): void {}

  openVideo(url?) {
    if (url) _log(url);

    const dialogRef = this.dialog.open(VideosModalComponent, {
      panelClass: 'backgroung-video',
      width: '900px',
      data: { url },
    });
  }
}
